import React, {Fragment} from "react"
import {
  Route,
  Switch,
} from 'react-router-dom'

import {connect} from "react-redux"
import CircularProgress from '@material-ui/core/CircularProgress'
import { I18n } from 'react-redux-i18n'

import {history} from "../helpers/history"
import Home from "./pages/Home"
import Login from "./pages/Login"
import Appointment from "./pages/Appointment"
import NewAppointment from "./pages/newAppointment/NewAppointment"
import UpdateAppointment from "./pages/updateAppointment/UpdateAppointment"
import Month from "./pages/month/Month"
import Week from "./pages/Week"
import Error404 from "./error/404"
import Settings from "./pages/Settings"
import OtherUserLogin from "./pages/OtherUserLogin"

import {
  ConnectedRouter
} from "react-router-redux"

import PrivateRoute from '../helpers/PrivateRoute'

// User actions
import {login, logout} from '../actions/userActions'

// Set material ui colors
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import SimpleSnackbar from './Snackbar'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#34bff2',
      light: '#78f2ff',
      dark: '#008fbf',
      contrastText: '#fff',
    },
    secondary: {
      main: '#666666',
      light: '#949494',
      dark: '#3c3c3c',
      contrastText: '#ffffff'
    },
  },
})

class App extends React.Component {
  // User functions
  login = (username, password) => {
    this.props.dispatch(login(username, password))
  }

  logout = () => {
    this.props.dispatch(logout())
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        {this.props.user.loggingIn ?
          (
            <div style={{textAlign: 'center', marginTop: '5rem'}}>
              <CircularProgress/>
              <h3>{I18n.t('login.logging_in')}</h3>
            </div>
          )
          :
          (
            <Fragment>
              <ConnectedRouter history={history}>
                <Switch>
                  <Route exact path='/login' component={Login} />
                  <PrivateRoute exact path='/' drawComponent={Home}></PrivateRoute>
                  <PrivateRoute exact path='/other-user' drawComponent={OtherUserLogin}></PrivateRoute>
                  <PrivateRoute exact path='/appointment/info/:id' drawComponent={Appointment}></PrivateRoute>
                  <PrivateRoute exact path='/month/:month' drawComponent={Month}></PrivateRoute>
                  <PrivateRoute exact path='/week/:week' drawComponent={Week}></PrivateRoute>
                  <PrivateRoute exact path='/appointment/new' drawComponent={NewAppointment}></PrivateRoute>
                  <PrivateRoute exact path='/appointment/edit/:id' drawComponent={UpdateAppointment}></PrivateRoute>
                  <PrivateRoute exact path='/settings' drawComponent={Settings}></PrivateRoute>
                  <Route path='*' component={Error404}/>
                </Switch>
              </ConnectedRouter>
              <SimpleSnackbar />
            </Fragment>
          )
        }
      </MuiThemeProvider>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/js/components/App.js